// extracted by mini-css-extract-plugin
module.exports = {"inspect-footer":"inspect-footer___42g4_"};